<template>
  <div class="site-nav">
    <!-- 1. 头部 Hero 区域 -->
    <header class="hero">
      <img class="hero-logo" src="@/assets/logo.png" alt="logo" />
      <h1 class="hero-title">小不点的技术分享</h1>
      <p class="hero-subtitle">个人站点导航 · 快速跳转各个项目网站</p>
    </header>

    <!-- 2. 主体内容区：网站卡片列表 -->
    <main class="content">
      <div class="card-grid">
        <div
          v-for="site in sites"
          :key="site.name"
          class="site-card"
          role="button"
          tabindex="0"
          @click="onCardClick(site)"
          @keyup.enter="onCardClick(site)"
        >
          <div v-if="site.icon" class="card-icon">
            <img :src="site.icon" :alt="site.name" />
          </div>
          <div class="card-name">{{ site.name }}</div>
          <div class="card-desc">{{ site.desc }}</div>
          <span class="card-btn">👉 访问站点</span>
        </div>
      </div>
    </main>

    <!-- 3. 底部页脚区域 -->
    <footer class="footer">
      <span
        >Copyright © 2022-2026 All Rights Reserved.
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          >备案号:</a
        >
        <a
          href="https://beian.miit.gov.cn/"
          target="_blank"
          rel="noopener noreferrer"
          >京ICP备2022005571号-1</a
        >
      </span>
    </footer>
  </div>
</template>

<script>
export default {
  name: "SiteNav",
  data() {
    return {
      // 网站列表：后期新增只需往这里加一项即可
      // ready: true 表示已上线（点击新标签跳转），否则点击 toast 提醒
      sites: [
        {
          name: "工具箱",
          desc: "日常开发常用的在线小工具合集",
          url: "https://tool.lavenir.top/",
          ready: true,
        },
        {
          name: "个人笔记文档站",
          desc: "技术笔记、学习文档分享",
          url: "https://example.com/notes",
        },
        {
          name: "博客站点",
          desc: "原创技术文章、踩坑记录与思考",
          url: "https://example.com/blog",
        },
        {
          name: "AI工具笔记",
          desc: "AI 工具聚合、使用技巧与学习笔记分享",
          url: "/aitools",
          ready: true,
        },
        {
          name: "图床服务",
          desc: "图片上传、管理与外链分发",
          url: "https://example.com/cloud",
        },
        {
          name: "演示沙箱",
          desc: "前端组件与交互效果在线演示",
          url: "https://example.com/sandbox",
        },
      ],
    };
  },
  methods: {
    onCardClick(site) {
      if (site.url && site.url.startsWith("/")) {
        // 站内页面，使用路由跳转
        this.$router.push(site.url);
      } else if (site.ready) {
        window.open(site.url, "_blank", "noopener,noreferrer");
      } else {
        this.showToast("功能开发中，敬请期待~");
      }
    },
    showToast(message) {
      let toast = document.getElementById("site-nav-toast");
      if (!toast) {
        toast = document.createElement("div");
        toast.id = "site-nav-toast";
        toast.style.cssText = [
          "position:fixed",
          "left:50%",
          "top:24px",
          "transform:translateX(-50%)",
          "background:rgba(120,120,120,0.85)",
          "color:#fff",
          "padding:10px 20px",
          "border-radius:22px",
          "font-size:14px",
          "z-index:9999",
          "pointer-events:none",
          "opacity:0",
          "transition:opacity .25s ease",
        ].join(";");
        document.body.appendChild(toast);
      }
      toast.textContent = message;
      // 触发显示
      requestAnimationFrame(() => {
        toast.style.opacity = "1";
      });
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => {
        toast.style.opacity = "0";
      }, 1800);
    },
  },
};
</script>

<style lang="less" scoped>
.site-nav {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-image: url("~@/assets/background.png");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
}

/* 头部 Hero */
.hero {
  height: 40vh;
  min-height: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 16px;
}
.hero-logo {
  width: 88px;
  height: 88px;
  margin-bottom: 16px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
}
.hero-title {
  margin: 0;
  font-size: 34px;
  font-weight: 700;
  color: #ffffff;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
  letter-spacing: 2px;
}
.hero-subtitle {
  margin: 12px 0 0;
  font-size: 16px;
  color: #f5fbff;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.3);
}

/* 主体内容 */
.content {
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 24px 48px;
  box-sizing: border-box;
}
.card-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

/* 单张卡片 */
.site-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 28px 22px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(4px);
  box-shadow: 0 6px 18px rgba(30, 60, 90, 0.12);
  text-decoration: none;
  color: #2c3e50;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.site-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 14px 30px rgba(30, 60, 90, 0.22);
}
.card-icon {
  width: 56px;
  height: 56px;
  margin-bottom: 14px;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    border-radius: 10px;
  }
}
.card-name {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #1f3a52;
}
.card-desc {
  font-size: 13px;
  line-height: 1.6;
  color: #8a99a8;
  min-height: 42px;
  margin-bottom: 18px;
}
.card-btn {
  display: inline-block;
  padding: 8px 18px;
  border-radius: 20px;
  background: #4a90d9;
  color: #ffffff;
  font-size: 13px;
  transition: background 0.2s ease;
}
.site-card:hover .card-btn {
  background: #357abd;
}

/* 页脚 */
.footer {
  background: rgba(0, 0, 0, 0.45);
  color: #ffffff;
  font-size: 13px;
  letter-spacing: 1px;
  text-align: center;
  padding: 14px 16px;
  a {
    color: #cfe6ff;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
}

/* 平板：一行 2 张 */
@media (max-width: 992px) {
  .card-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* 手机：一行 1 张 */
@media (max-width: 600px) {
  .hero-title {
    font-size: 26px;
  }
  .hero-subtitle {
    font-size: 14px;
  }
  .content {
    padding: 24px 16px 36px;
  }
  .card-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
</style>
